<template>
  <div class="music pb-50">
    <van-sticky>
      <van-nav-bar :border="false">
        <template slot="left">
          <img :src="homeData.topLogo" class="logo-site">
        </template>
        <template slot="right">
          <div class="flex align-center">
            <router-link class="relative" to="/feedback">
              <i class="iconfont icon-yijianfankui"></i>
            </router-link>
          </div>
        </template>
      </van-nav-bar>
      <div class="tabs-wrapper">
        <div class="mr-tab pb-10">
          <div v-for="(item, index) in navList" :key="index" class="tab fs-14" :class="{ 'active': type === item.type}" @click="toggleTab(item.type)">{{ item.name }}</div>
        </div>
      </div>
      <van-search v-model="searchTitle" placeholder="搜索" style="padding-top: 0;" @search="search()" />
    </van-sticky>
    <van-pull-refresh v-model="isLoading" @refresh="onRefresh" class="bg-fff pt-20 flex-1">
      <div v-if="list.length" class="list">
        <div class="caption color-9DA4B3 fs-12">
          <span>您一共有<span class="color-FC3159">{{ total }}</span>首作品</span>
          <span class="mr-filter" @click="filterShow = !filterShow">
            <van-tag v-show="curFilterType" type="primary" plain class="mr-6 fs-12">{{ curFilterType }}</van-tag>
            <span class="flex align-center"><van-icon name="filter-o" class="color-D0E15" />筛选</span>
          </span>
        </div>
        <router-link tag="div" :to="item.album_type === 'single' ? `/music/single?id=${item.km_mid}&time=${item.createtime}` : `/music/album?id=${item.km_aid}&time=${item.createtime}`" v-for="item in list" :key="item.aid"><mr-item :music="item" @share="share"></mr-item></router-link>
        <van-pagination v-model="currentPage" :total-items="total" :items-per-page="10" @change="jumpTo" />
      </div>
      <van-empty v-else description="暂无作品" />
    </van-pull-refresh>

    <mr-share ref="MrShare" :music="music"></mr-share>
    <van-action-sheet v-model="filterShow" cancel-text="取消">
      <div class="content">
        <div v-for="item in filterOptions" :key="item.id" class="filter-item" :class="{ 'active': filterType === item.id }" @click="selectedFilter(item)">{{ item.name }}</div>
      </div>
    </van-action-sheet>
  </div>
</template>

<script>
import { getMusicList } from '@/api/music.js'
import { getHomeData } from '@/api/common.js'
import MrItem from '../components/item'
import { mapMutations } from 'vuex'
const menuStatus = {
  0: { id: 0, name: '全部' },
  1: { id: 1, name: '待完善资料' },
  2: { id: 2, name: '选发行范围' },
  3: { id: 3, name: '待签署授权' },
  4: { id: 4, name: '编辑审核中' },
  5: { id: 5, name: '作品被驳回' },
  6: { id: 6, name: '作品发行中' },
  7: { id: 7, name: '作品已上线' }
}
export default {
  name: 'MusicList',
  components: { MrItem },
  data() {
    return {
      searchTitle: '',
      activeName: 'Single',
      type: '0', // 当前的作品类型
      isLoading: false,
      currentPage: 1,
      list: [],
      total: 0,
      homeData: {},
      music: {}, // 分享music
      filterShow: false, // 筛选弹窗
      filterType: '' // 筛选的type
    }
  },
  computed: {
    navList() {
      return [
        { type: '0', name: '全部' },
        { type: '1,2,3', name: '准备/提交' },
        { type: '4,5', name: '审核/反馈' },
        { type: '6,7', name: '发行/分享' }
      ]
    },
    filterOptions() {
      let type = '0'
      if (this.type === '0') {
        type = '0,1,2,3,4,5,6,7'
      } else {
        type = this.type
      }
      return type.split(',').map(val => menuStatus[val])
    },
    curFilterType() {
      return this.filterType == 0 ? '' : menuStatus[this.filterType].name
    }
  },
  async created() {
    this.$store.commit('TOGGLE_LOADING', true)
    try {
      this.type = this.$route.query.type && String(this.$route.query.type) || '0'
      await this.getHomeData()
      await this.getMusicList()
    } finally {
      this.$store.commit('TOGGLE_LOADING', false)
    }
  },
  methods: {
    async getMusicList() {
      const res = await getMusicList({ type: this.filterType || this.type, page: this.currentPage, keyword: this.searchTitle })
      const { list, total } = res.data
      this.list = list || []
      this.total = total || 0
    },
    async search() {
      this.TOGGLE_LOADING(true)
      this.filterType = '' // 清空筛选条件
      await this.getMusicList()
      this.TOGGLE_LOADING(false)
    },
    async toggleTab(type) {
      this.type = type
      this.currentPage = 1
      this.filterType = '' // 清空筛选条件
      this.TOGGLE_LOADING(true)
      try {
        await this.getMusicList()
      } finally {
        this.TOGGLE_LOADING(false)
      }
    },
    async getHomeData() {
      const res = await getHomeData({})
      this.homeData = res.data
    },
    async jumpTo(page) {
      this.currentPage = page
      try {
        this.TOGGLE_LOADING(true)
        await this.getMusicList()
      } finally {
        this.TOGGLE_LOADING(false)
         window.scrollTo(0, 0)
      }
    },
    async onRefresh() {
      this.$store.commit('TOGGLE_LOADING', true)
      try {
        await this.getMusicList()
      } finally {
        this.$store.commit('TOGGLE_LOADING', false)
        this.isLoading = false
      }
    },
    share(item) {
      this.music = item
      setTimeout(() => {
        this.$refs.MrShare.share({
          album_type: item.album_type,
          singer: item.album_type === 'single' ? item.singer : undefined,
          writer: item.album_type === 'single' ? item.writer : undefined,
          composer: item.album_type === 'single' ? item.composer : undefined
        })
      }, 20)
    },
    async selectedFilter(item) {
      this.filterType = item.id
      this.filterShow = false
      this.TOGGLE_LOADING(true)
      await this.getMusicList()
      this.TOGGLE_LOADING(false)
    },
    ...mapMutations(['TOGGLE_LOADING'])
  }
}
</script>

<style lang="scss" scoped>
@import "@/style/home.scss";
.music{
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  height: auto;
  /deep/ .van-pull-refresh__track{
    min-height: calc(100vh - 90Px - 130px);
  }
}
.feed{
  position: fixed;
  top: 20px;
  right: 20px;
  display: flex;
  align-items: center;
  white-space: nowrap;
}
.nav{
  font-size: 28px;
  padding: 16px 0 0;
  background-color: #fff;
  .tabs{
    padding: 0 26px;
    strong{
      color: #B7BDCA;
      &.active{
        color: #0D0E15;
      }
    }
  }
}
.list{
  padding: 16px 0;
  background-color: #fff;
  border-top-left-radius: 16px;
  border-top-right-radius: 16px;
  box-shadow:  0 3px 10px 5px #f0f0f0;
  .caption{
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 16px 16px;
    .mr-filter{
      color: #0D0E15;
      font-size: 12px;
      display: flex;
      align-items: center;
      .color-D0E15{
        color:#0D0E15;
      }
    }
  }
}
.content{
  .filter-item{
    padding: 15px 0;
    text-align: center;
    font-size: 14px;
    transition: all .3s;
    user-select: none;
    &:active{
      background-color: #f2f3f5;
    }
    &.active{
      color: #FC3159;
    }
  }
}
</style>
